module.exports = __webpack_public_path__ + "img/cancel-appointments.bb92a93b.svg";